import { render, staticRenderFns } from "./provide.vue?vue&type=template&id=0f241954&scoped=true"
import script from "./provide.vue?vue&type=script&lang=js"
export * from "./provide.vue?vue&type=script&lang=js"
import style0 from "./provide.vue?vue&type=style&index=0&id=0f241954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f241954",
  null
  
)

export default component.exports